import { render, staticRenderFns } from "./ContratoDadosGerais.vue?vue&type=template&id=469e7dd3&"
import script from "./ContratoDadosGerais.vue?vue&type=script&lang=js&"
export * from "./ContratoDadosGerais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports